import useCountUpOnView from "../../../hooks/useCountUpOnView";

/**
 * Render a viewport-triggered animated number.
 * Translation: Render a viewport-triggered animated number.
 *
 * @param {Object} props - Animated counter props.
 * @returns {JSX.Element} Counter element.
 */
const AnimatedCounter = ({
  as: Component = "span",
  target,
  prefix = "",
  suffix = "",
  decimals = 0,
  className = "",
  enabled = true,
}) => {
  const { elementRef, displayValue, progress } = useCountUpOnView(target, {
    prefix,
    suffix,
    decimals,
    enabled,
  });

  return (
    <Component
      ref={elementRef}
      className={className}
      data-progress={progress}
      aria-label={displayValue}
    >
      {displayValue}
    </Component>
  );
};

export default AnimatedCounter;
